'use client';
import KilnWordmarkFooter from '@/components/ui/kiln-wordmark-footer';
import { CONTACT, ui } from '../data';
import { useLang } from './Lang';

// Même footer que le site freelance, réduit à l'essentiel et aux couleurs du portfolio (rouge vin, papier).
export default function PortfolioFooter() {
    const { t } = useLang();
    return (
        <KilnWordmarkFooter
            brand="Gauthier Rodriguez"
            wordmark="Gauthier Rodriguez"
            wordmarkFont="var(--pf-serif), serif"
            uppercase={false}
            headingStyle={{ fontFamily: 'var(--pf-serif), serif', fontStyle: 'italic', fontWeight: 400, fontSize: '1.5em' }}
            address={[t(ui.role), `↳ ${CONTACT.city}`]}
            followTitle="Instagram"
            socials={[[{ label: '@nonspeculativeart', href: CONTACT.instagram }]]}
            year={new Date().getFullYear()}
            legal={[
                { label: t({ fr: 'Mentions légales', en: 'Legal notice' }), href: '/mentions-legales' },
                { label: t({ fr: 'Confidentialité', en: 'Privacy' }), href: '/politique-confidentialite' },
                { label: t({ fr: 'CGV', en: 'Terms' }), href: '/cgv' },
                { label: 'RGPD', href: '/rgpd' },
            ]}
            surface="#8E2A37"
            deep="#7A1F2B"
            ink="#F1ECE3"
            paper="#7A1F2B"
            tileScale={0.3}
        />
    );
}
